/**
 * The switcher's own catalogue: the popover, the full listing page, and the
 * missing-capability state, none of which any other feature area names.
 */

import { defineCatalogue } from '../../../i18n';

export const switcherCatalogue = defineCatalogue(
  {
    'dialog.label': 'Trocar de organização ou campanha',
    'search.placeholder': 'Buscar organização ou campanha',
    'search.empty': 'Nada encontrado.',
    empty: 'Você ainda não faz parte de nenhuma organização.',
    noCampaignYet: 'Esta organização já existe e ainda não tem nenhuma campanha nela.',
    createCampaign: 'Criar campanha',
    viewAll: 'Ver todas as organizações',
    'trigger.none': 'Escolher organização',
    'error.body': 'Não foi possível carregar suas organizações.',
    'page.heading': 'Onde você quer trabalhar?',
    'page.createOrganisation': 'Criar uma organização',
    'role.orgAdmin': 'Admin da organização',
    'role.analyst': 'Analista',

    'card.open': 'Abrir organização',
    'card.campaignsLabel': 'Campanhas de {organisation}',
    'card.noCampaigns': 'sem campanha',
    'card.campaigns.other': '{n} campanhas',
    'card.campaigns.one': '{n} campanha',
    'card.createFirstCampaign': 'Criar a primeira campanha',

    'figures.balance': 'Créditos disponíveis',
    'figures.consumption': 'Consumo · 7d',
    'figures.consumption.none': 'sem consumo',
    'figures.runway.none': 'nada consumindo ainda',
    'figures.runway.weeks.other': '~{n} semanas no ritmo atual',
    'figures.runway.weeks.one': '~{n} semana no ritmo atual',

    'row.state.active': 'Coletando',
    'row.state.paused': 'Pausada',
    'row.state.archived': 'Encerrada',
    'row.reach': 'Alcance · 7d',
    'row.reach.none': 'sem leitura',

    'invitations.invitedBy': '{tenant} convidou você',
    'invitations.error': 'Não foi possível carregar seus convites.',
    'invitations.acceptFailed': 'Não foi possível aceitar. Tente novamente.',

    'notYours.title': 'Esta organização não é sua',
    'notYours.body': 'Ela não está entre as suas. Volte ao início para continuar de onde estava.',
    'notYours.action': 'Ir para o início',
  },
  {
    'dialog.label': 'Switch organisation or campaign',
    'search.placeholder': 'Search organisation or campaign',
    'search.empty': 'Nothing found.',
    empty: 'You do not belong to any organisation yet.',
    noCampaignYet: 'This organisation already exists and does not have a campaign in it yet.',
    createCampaign: 'Create campaign',
    viewAll: 'See all organisations',
    'trigger.none': 'Choose organisation',
    'error.body': 'Your organisations could not be loaded.',
    'page.heading': 'Where do you want to work?',
    'page.createOrganisation': 'Create an organisation',
    'role.orgAdmin': 'Organisation admin',
    'role.analyst': 'Analyst',

    'card.open': 'Open organisation',
    'card.campaignsLabel': '{organisation} campaigns',
    'card.noCampaigns': 'no campaign',
    'card.campaigns.other': '{n} campaigns',
    'card.campaigns.one': '{n} campaign',
    'card.createFirstCampaign': 'Create the first campaign',

    'figures.balance': 'Available credits',
    'figures.consumption': 'Consumption · 7d',
    'figures.consumption.none': 'no consumption',
    'figures.runway.none': 'nothing consumed yet',
    'figures.runway.weeks.other': '~{n} weeks at the current pace',
    'figures.runway.weeks.one': '~{n} week at the current pace',

    'row.state.active': 'Collecting',
    'row.state.paused': 'Paused',
    'row.state.archived': 'Ended',
    'row.reach': 'Reach · 7d',
    'row.reach.none': 'no reads yet',

    'invitations.invitedBy': '{tenant} invited you',
    'invitations.error': 'Your invitations could not be loaded.',
    'invitations.acceptFailed': 'Could not accept. Try again.',

    'notYours.title': 'This organisation is not yours',
    'notYours.body': 'It is not among yours. Go back to start to continue where you were.',
    'notYours.action': 'Go to start',
  },
);

export const sw = switcherCatalogue.t;
